import React from 'react';

import { useWorkflowQuery } from '@dashboard/generated/wp/platform';
import { Skeleton, Typography } from '@mui/material';

type Props = {
  workflowId: string | null;
};

export default function WorkflowNameField({ workflowId }: Props) {
  const { data } = useWorkflowQuery({ variables: { id: workflowId ?? '' }, skip: workflowId === null });
  if (workflowId === null) {
    return (
      <Typography variant="h3" component="h1">
        <em>None</em>
      </Typography>
    );
  }

  const workflow = data?.Workflow;

  if (workflow === undefined) {
    return (
      <Typography variant="h3" component="h1">
        <Skeleton width={64} />
      </Typography>
    );
  }

  return (
    <Typography variant="h3" component="h1">
      {workflow.name}
    </Typography>
  );
}
